/* eslint-disable no-lone-blocks */
import React, { useContext, useEffect, useState } from "react";
import {
  Autocomplete,
  Box,
  Button,
  Card,
  Chip,
  FormControl,
  Grid,
  IconButton,
  MenuItem,
  OutlinedInput,
  Paper,
  Select,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import SimpleBar from "simplebar-react";
import { getDownloadURL, ref, uploadBytesResumable } from "firebase/storage";
import { v4 as uuidv4 } from "uuid";
import { useNavigate } from "react-router-dom";
import {
  arrayUnion,
  collection,
  doc,
  getDoc,
  getDocs,
  query,
  setDoc,
  updateDoc,
  where,
} from "firebase/firestore";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { Warning } from "@mui/icons-material";
import FileUploadNewVersion from "../common/FileUploadNewVersion";
import AddBrand from "../../pages/Shopping/Brands/AddBrand";
import { db, storage } from "../../firebaseConfig";
import AddVariant from "../../pages/Shopping/Stores/AddVariant/AddVariant";
import VariantTable from "../../pages/Shopping/Stores/VariantTable/VariantTable";
import StoreStepperContext from "../../context/storeStepperContext";
import { Delete as DeleteIcon } from "@mui/icons-material";

function AddProductCatalog() {
  const {
    storeformData,
    setStoreFormData,
    checkForEdit,
    setCheckForEdit,
    productIdForEdit,
    setProductIdForEdit,
    addProductFromOverviewDocId,
    addProductFromOverview,
    setAddProductFromOverview,
    setAddProductFromOverviewDocId,
    setAddProductForMasterList,
    productCatalog,
    brandReload,
    productCatalogData,
    setProductCatalogData,
  } = useContext(StoreStepperContext);

  const user = useSelector((state) => state.auth.value);
  const [selectedFiles, setSelectedFiles] = useState(null);
  const [selectedValue, setSelectedValue] = useState([]);
  const [selectedProductDesignation, setSelectedProductDesignation] = useState(
    []
  );
  const [variants, setVariants] = useState([]);
  const [clearVariant, setClearVariant] = useState(false);
  const [brandToggal, setBrandToggal] = useState(false);
  const navigate = useNavigate();

  const [categories, setCategories] = useState([]);
  const [brands, setBrands] = useState([]);
  const [filteredBrands, setFilteredBrands] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [copyItemFromSuggestion, setCopyItemFromSuggestion] = useState(false);
  const [productToggal, setProductToggal] = useState(false);
  const [allProducts, setAllProducts] = useState([]);
  const [newProduct, setNewProduct] = useState({
    name: "",
    quantity: 1,
    weight: 0,
    price: 0,
  });

  useEffect(() => {
    const totalQuantity = productCatalogData.parcelProducts.reduce(
      (sum, product) => sum + Number(product.quantity),
      0
    );
    const totalWeight = productCatalogData.parcelProducts.reduce(
      (sum, product) => sum + Number(product.weight),
      0
    );
    const totalPrice = productCatalogData.parcelProducts.reduce(
      (sum, product) => sum + Number(product.price),
      0
    );

    setProductCatalogData((prev) => ({
      ...prev,
      totalWeight: totalWeight,
      fullPrice: totalPrice,
      parcelPrice: totalQuantity,
    }));
  }, [productCatalogData.parcelProducts, setProductCatalogData]);

  const handleAddProducts = () => {
    if (productCatalogData.productName.trim()) {
      const newParcelProduct = {
        id: uuidv4(),
        name: productCatalogData.productName,
        quantity: productCatalogData.productStock || 1,
        weight: productCatalogData.productWeight || 0,
        price: productCatalogData.productPrice || 0,
      };

      setProductCatalogData((prev) => ({
        ...prev,
        parcelProducts: [...(prev.parcelProducts || []), newParcelProduct],
      }));
    } else {
      console.log("Product name is empty, not adding.");
    }
  };

  const handleEditParcelProduct = (id, field, value) => {
    setProductCatalogData((prev) => ({
      ...prev,
      parcelProducts: prev.parcelProducts.map((product) =>
        product.id === id ? { ...product, [field]: value } : product
      ),
    }));
  };

  const handleDeleteParcelProduct = (id) => {
    setProductCatalogData((prev) => {
      // Ensure `parcelProducts` is always an array before filtering
      const updatedProducts = prev.parcelProducts
        ? prev.parcelProducts.filter((product) => product.id !== id)
        : [];

      return { ...prev, parcelProducts: updatedProducts };
    });
  };

  const [errors, setErrors] = useState({
    productName: "",
    productCategory: "",
    productPrice: "",
    productWeight: "",
    productStock: "",
    productDescription: "",
  });

  useEffect(() => {
    if (user?.role === "Superadmin") {
      setStoreFormData((prev) => ({
        ...prev, // Preserve existing values
        storeCurrency: "$",
        storeWeight: "Lb",
      }));
    }
  }, [user?.role, setStoreFormData]);

  // Validation function
  const validateFields = () => {
    const newErrors = {
      // productName:
      //   productCatalogData.productType && productCatalogData?.productName
      //     ? ""
      //     : "Name is required.",
      productCategory: productCatalogData?.productCategory
        ? ""
        : "Category is required.",
      productPrice: productCatalogData?.productPrice
        ? /^\d+(\.\d{1,2})?$/.test(productCatalogData?.productPrice)
          ? ""
          : "Invalid price format."
        : "Price is required.",
      productWeight: productCatalogData?.productWeight
        ? /^\d+(\.\d{1,2})?$/.test(productCatalogData?.productWeight)
          ? ""
          : "Invalid weight format."
        : "Weight is required.",
      productStock: productCatalogData?.productStock
        ? /^\d+$/.test(productCatalogData?.productStock)
          ? ""
          : "Stock must be a valid number."
        : "Stock is required.",
      productDescription: productCatalogData?.productDescription
        ? ""
        : "Description is required.",
    };
    console.log(newErrors, "------------------newErrors----------------------");
    setErrors(newErrors);

    // Check if all fields are valid
    return Object.values(newErrors).every((error) => error === "");
  };

  const handleSave = () => {
    if (validateFields()) {
      handleAddNewToMasterTableProduct();
    } else {
      toast.error("Please fix the validation errors.");
    }
  };

  const toggleBrand = () => {
    setBrandToggal(!brandToggal);
  };

  useEffect(() => {
    const fetchMasterProducts = async () => {
      try {
        const masterListRef = collection(db, "productMasterList");
        const masterListSnapshot = await getDocs(masterListRef);

        const products = await Promise.all(
          masterListSnapshot.docs.map(async (doc) => {
            const data = doc.data();
            let updatedImageUrls = [];

            // Ensure productImage is processed as an array
            const imagePaths = Array.isArray(data.productImage)
              ? data.productImage
              : [data.productImage].filter(Boolean); // Wrap single image in an array

            if (imagePaths.length > 0) {
              try {
                updatedImageUrls = await Promise.all(
                  imagePaths.map(async (imagePath) => {
                    try {
                      const imageRef = ref(storage, imagePath);
                      return await getDownloadURL(imageRef);
                    } catch (error) {
                      console.error(
                        "Error fetching image URL for product:",
                        data.productName,
                        imagePath,
                        error
                      );
                      return imagePath; // Return the original path if URL fetching fails
                    }
                  })
                );
              } catch (error) {
                console.error("Error processing product images:", error);
              }
            }

            return {
              id: doc.id,
              ...data,
              productImage:
                updatedImageUrls.length > 0
                  ? updatedImageUrls
                  : data.productImage, // Update productImage with new URLs or retain original paths
            };
          })
        );

        setAllProducts(products);
      } catch (error) {
        console.error("Error fetching master product list:", error);
      }
    };

    fetchMasterProducts();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      // Fetch categories
      const categorySnapshot = await getDocs(collection(db, "brandCategory"));
      const fetchedCategories = categorySnapshot.docs.map(
        (doc) => doc.data().name
      );
      setCategories(fetchedCategories);

      // Fetch brands
      const brandSnapshot = await getDocs(collection(db, "brands"));
      const fetchedBrands = brandSnapshot.docs.map((doc) => ({
        brandName: doc.data().brandName,
        brandCategory: doc.data().brandCategory,
      }));

      setBrands(fetchedBrands);
    };

    fetchData();
  }, [brandReload]);

  useEffect(() => {
    // Filter brands based on the selected category
    if (selectedCategory) {
      const filtered = brands.filter(
        (brand) => brand.brandCategory === selectedCategory
      );
      setFilteredBrands(filtered);
    } else {
      setFilteredBrands([]);
    }
  }, [selectedCategory, brands]);

  useEffect(() => {
    if (productCatalog && productIdForEdit) {
      const productEditData = async () => {
        try {
          const masterListReff = collection(db, "productMasterList");
          const q = query(
            masterListReff,
            where("productId", "==", productIdForEdit)
          );
          const masterListSnapshot = await getDocs(q);

          let productObject = null;
          if (!masterListSnapshot.empty) {
            const doc = masterListSnapshot.docs[0];
            productObject = doc.data();
          }

          if (productObject) {
            setProductCatalogData((prev) => ({
              ...prev,
              ...productObject,
              storeImages: productObject.productImage || [],
            }));
            setSelectedCategory(productObject?.productCategory || "");
            setSelectedValue(productObject.productTags || []);
            setSelectedProductDesignation(
              productObject?.productDesignation || []
            );
            setVariants(productObject.productVarient || []);
          } else {
          }
        } catch (error) {
          console.error("Error fetching product data:", error);
        }
      };

      productEditData();
    }
  }, [productIdForEdit, productCatalog, setProductCatalogData]);

  // useEffect(() => {
  //   if (productCatalog === true) {
  //     console.log("1212123123");
  //     const producteditData = async () => {
  //       const masterListReff = collection(db, "productMasterList");
  //       const q = query(
  //         masterListReff,
  //         where("productId", "==", productIdForEdit)
  //       );
  //       const masterListSnapshott = await getDocs(q);

  //       let productObject = null;
  //       if (!masterListSnapshott.empty) {
  //         const doc = masterListSnapshott.docs[0];
  //         productObject = doc.data();
  //       }

  //       //  setProductData(productObject);

  //       console.log("productObject: ", productObject);

  //       if (productObject) {
  //         setStoreFormData((prev) => ({
  //           ...prev,
  //           currentProduct: {
  //             ...productObject,
  //             // storeID: storeData.storeID,
  //             storeImages: productObject.productImage,
  //           },
  //         }));
  //         setSelectedCategory(productObject?.productCategory);
  //         setSelectedValue(productObject.productTags || []);
  //         setSelectedProductDesignation(
  //           productObject?.productDesignation || []
  //         );
  //         setVariants(productObject.productVarient || []);
  //       } else {
  //         console.log("No product found with the given ID.");
  //       }
  //     };

  //     producteditData();
  //   }
  // }, [productIdForEdit, setStoreFormData, productCatalog]);

  useEffect(() => {
    if (addProductFromOverview === true && addProductFromOverviewDocId) {
      (async () => {
        try {
          const storeRef = doc(db, "stores", addProductFromOverviewDocId);

          const storeSnapshot = await getDoc(storeRef);

          if (storeSnapshot.exists()) {
            const storeData = storeSnapshot.data();
            const productToEdit = storeData.products.find(
              (product) => product.productId === productIdForEdit
            );

            if (productToEdit) {
              setStoreFormData((prev) => ({
                ...prev,
                currentProduct: {
                  ...productToEdit,
                  storeID: storeData.storeID,
                  storeImages: storeData.storeImages,
                },
              }));
              setSelectedCategory(productToEdit?.productCategory);
              setSelectedValue(productToEdit.productTags || []);
              setSelectedProductDesignation(
                productToEdit?.productDesignation || []
              );
              setVariants(productToEdit.productVarient || []);
            } else {
              console.log("No product found with the given ID.");
            }
          } else {
            console.log("Store document does not exist.");
          }
        } catch (error) {
          console.error("Error fetching product: ", error);
        }
      })();
    } else if (checkForEdit && productIdForEdit) {
      const productToEdit = storeformData?.products?.find(
        (product) => product?.productId === productIdForEdit
      );

      if (productToEdit) {
        setStoreFormData((prev) => ({
          ...prev,
          currentProduct: { ...productToEdit },
        }));
        setSelectedCategory(productToEdit?.productCategory);
        setSelectedValue(productToEdit.productTags || []);
        setSelectedProductDesignation(productToEdit?.productDesignation || []);
        setVariants(productToEdit.productVarient || []);
      }
    } else {
      // Initialize `currentProduct` if not already set
      setStoreFormData((prev) => ({
        ...prev,
        currentProduct: prev.currentProduct || {
          productName: "",
          productCategory: "",
          productBrand: "",
          productPrice: "",
          productWeight: "",
          productStock: "",
          productDimentionL: "",
          productDimentionW: "",
          productDimentionH: "",
          productDescription: "",
          productTags: [],
          productImage: "",
          productVarient: [],
        },
      }));
    }
  }, [
    addProductFromOverview,
    addProductFromOverviewDocId,
    checkForEdit,
    productIdForEdit,
    setStoreFormData,
    storeformData.products,
  ]);

  const [inputValue, setInputValue] = useState("");
  const [filteredProducts, setFilteredProducts] = useState([]);

  const handleChangeFormData = (e) => {
    const { name, value } = e.target;

    if (name === "productCategory") {
      setSelectedCategory(value);
    }

    if (name === "productName") {
      setInputValue(value);
      setNewProduct({ ...newProduct, name: value });

      if (value) {
        const filtered = allProducts.filter((product) =>
          product.productName.toLowerCase().includes(value.toLowerCase())
        );
        setFilteredProducts(filtered);
      } else {
        setFilteredProducts([]);
      }
    }

    setProductCatalogData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleAddNewToMasterTableProduct = async () => {
    let newProduct;

    setProductCatalogData((prev) => {
      newProduct = {
        ...prev,
        productId: uuidv4(),
        productStatus: user?.role === "Superadmin" ? true : false,
        productUnderReview: false,
      };
      return newProduct;
    });

    try {
      const masterListRef = doc(db, "productMasterList", newProduct.productId);

      await setDoc(masterListRef, {
        ...newProduct,
      });

      toast.success("Product added successfully!");

      setAddProductForMasterList(false);
      setAddProductFromOverview(false);
      setAddProductFromOverviewDocId();
      setCopyItemFromSuggestion(false);
      setProductIdForEdit();
      setCheckForEdit(false);

      setProductCatalogData((prev) => ({
        ...prev,
        productType: false,
        parcelName: "",
        totalWeight: "",
        fullPrice: "",
        parcelPrice: "",
        parcelProducts: [],
        storeImages: [],
        productBrand: "",
        productCategory: "",
        productImage: "",
        productDescription: "",
        productDimentionH: 0,
        productDimentionL: 0,
        productDimentionW: 0,
        productName: "",
        productPrice: 0,
        productStock: 0,
        productWeight: 0,
        productVarient: [],
        productKeyFeatures: "",
        productUseCase: "",
        productBenefits: "",
        productNutritionalValue: "",
        productProductSpecifications: "",
        productTags: [],
        productDesignation: "",
      }));

      navigate("/shopping/add-products");
    } catch (error) {
      console.error("Error adding product: ", error);
    }
  };

  const uploadImage = async (file) => {
    try {
      // Create a storage reference for the file
      const storageRef = ref(storage, `/store_products/${file.name}`);

      // Upload the file and wait for the snapshot
      const uploadTask = uploadBytesResumable(storageRef, file);
      const snapshot = await uploadTask;

      // Get the downloadable URL
      const photoUrl = await getDownloadURL(snapshot.ref);

      // Return the URL for further processing
      return photoUrl;
    } catch (error) {
      console.error("Error uploading file:", error);
      return null; // Return null for failed uploads
    }
  };

  const onUploadChange = async (fileArray) => {
    setSelectedFiles(fileArray); // Update local state for selected files

    try {
      // Upload files and get URLs in the same order
      const uploadedUrls = await Promise.all(
        fileArray.map((file) => uploadImage(file))
      );

      // Filter out any null entries (failed uploads)
      const validUrls = uploadedUrls.filter((url) => url !== null);

      setProductCatalogData((prev) => ({
        ...prev,
        productImage: checkForEdit
          ? [...(prev.productImage || []), ...validUrls]
          : validUrls,
      }));
    } catch (error) {
      console.error("Error uploading files:", error);
    }
  };

  const handleChangeTags = (event, newValue) => {
    setSelectedValue(newValue);
    setProductCatalogData((prev) => ({
      ...prev,
      productTags: newValue,
    }));
  };

  const handleChangeDesignation = (event, newValue) => {
    if (newValue?.length <= 2) {
      setSelectedProductDesignation(newValue);
      setProductCatalogData((prev) => ({
        ...prev,
        productDesignation: newValue,
      }));
    }
  };

  const handleAddVariant = (newVariants) => {
    setVariants(newVariants);
    setProductCatalogData((prev) => ({
      ...prev,
      productVarient: newVariants,
    }));
  };

  function highlightText(text, searchTerm) {
    if (!searchTerm) return text;

    const parts = text.split(new RegExp(`(${searchTerm})`, "gi"));
    return parts.map((part, index) =>
      part.toLowerCase() === searchTerm.toLowerCase() ? (
        <span
          key={index}
          style={{
            backgroundColor: "yellow",
            fontWeight: "bold",
          }}
        >
          {part}
        </span>
      ) : (
        part
      )
    );
  }

  return (
    <>
      <Box>
        <SimpleBar
          forceVisible="x"
          autoHide={true}
          style={{
            overflowX: "auto",
            maxHeight: "77vh",
          }}
          className="custom-scrollbar"
        >
          <Box
            sx={{
              width: "70%",
              padding: "20px",
              backgroundColor: "white",
            }}
          >
            {user?.role !== "Superadmin" && checkForEdit === false && (
              <Box
                sx={{
                  marginBottom: "24px",
                  height: "45px",
                  border: "1px solid rgba(242, 153, 74, 1)",
                  backgroundColor: "rgba(251, 222, 197, 1)",
                  display: "flex",
                  alignItems: "center",
                  paddingX: 2,
                  borderRadius: "4px",
                }}
              >
                <img src={Warning} alt="warning" width="24px" height="24px" />
                <Typography sx={{ fontSize: "14px", marginLeft: 1 }}>
                  This product is pending approval. Once it's approved, it will
                  be introduced as a new product.
                </Typography>
              </Box>
            )}

            {/* Peoduct type button  */}
            <Stack direction={"row"} gap={3}>
              <Grid item sx={{ marginBottom: "10px" }}>
                <Button
                  variant="outlined"
                  color="primary"
                  sx={{
                    marginRight: "10px",
                    backgroundColor: !productCatalogData.productType
                      ? "#481AA3"
                      : "white",
                    color: !productCatalogData.productType
                      ? "white"
                      : "#481AA3",
                    borderColor: "#481AA3",
                    "&:hover": {
                      backgroundColor: !productCatalogData.productType
                        ? "#481AA3"
                        : "lightgray",
                    },
                  }}
                  // onClick={() => setProductToggal(false)}
                  onClick={() =>
                    setProductCatalogData((prev) => ({
                      ...prev,
                      productType: false,
                    }))
                  }
                >
                  Single Product
                </Button>

                <Button
                  variant="outlined"
                  color="primary"
                  sx={{
                    backgroundColor: productCatalogData.productType
                      ? "#481AA3"
                      : "white",
                    color: productCatalogData.productType ? "white" : "#481AA3",
                    borderColor: "#481AA3",
                    "&:hover": {
                      backgroundColor: productCatalogData.productType
                        ? "#481AA3"
                        : "lightgray",
                    },
                  }}
                  // onClick={() => setProductToggal(true)}
                  onClick={() =>
                    setProductCatalogData((prev) => ({
                      ...prev,
                      productType: true,
                    }))
                  }
                >
                  Parcel
                </Button>
              </Grid>
            </Stack>

            {productCatalogData.productType && (
              <Stack direction={"row"} gap={3}>
                <Grid item>
                  <Typography sx={{ fontSize: "14px", fontWeight: "500" }}>
                    Parcel Name
                  </Typography>
                  <FormControl
                    fullWidth
                    sx={{ mt: 1, minWidth: "61vw" }}
                    size="small"
                  >
                    <OutlinedInput
                      type="text"
                      sx={{ height: "35px" }}
                      placeholder="Enter Name"
                      name="parcelName"
                      // value={storeformData?.parcelDetails?.parcelName || ""}
                      value={productCatalogData.parcelName || ""}
                      onChange={handleChangeFormData}
                      autoComplete="off"
                    />
                  </FormControl>
                </Grid>
              </Stack>
            )}

            {!productCatalogData.productType && (
              <Stack direction={"row"} gap={3}>
                <Grid item>
                  <Typography sx={{ fontSize: "14px", fontWeight: "500" }}>
                    Name<span style={{ color: "#FF5630" }}>*</span>
                  </Typography>
                  <FormControl
                    fullWidth
                    sx={{ mt: 1, minWidth: "61vw" }}
                    size="small"
                  >
                    <OutlinedInput
                      type="text"
                      sx={{ height: "35px" }}
                      placeholder="Enter Name"
                      name="productName"
                      // value={storeformData.currentProduct?.productName || ""}
                      value={productCatalogData.productName || ""}
                      onChange={handleChangeFormData}
                      autoComplete="off"
                    />
                    {errors.productName && (
                      <Typography
                        sx={{
                          color: "red",
                          fontSize: "12px",
                          marginTop: "4px",
                        }}
                      >
                        {errors.productName}
                      </Typography>
                    )}
                  </FormControl>
                </Grid>
              </Stack>
            )}

            {productCatalogData.productType && (
              <Stack direction={"row"} gap={3} sx={{ marginTop: "1rem" }}>
                <Grid item>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "flex-end",
                      gap: "10px",
                    }}
                  >
                    <FormControl
                      fullWidth
                      sx={{ mt: 1, minWidth: "53.5vw" }}
                      size="small"
                    >
                      <OutlinedInput
                        type="text"
                        sx={{ height: "35px" }}
                        placeholder="Search products to add..."
                        name="productName"
                        // value={storeformData.currentProduct?.productName || ""}
                        value={productCatalogData.productName || ""}
                        onChange={handleChangeFormData}
                        autoComplete="off"
                      />
                    </FormControl>
                    {productCatalogData.productType && (
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={handleAddProducts}
                        fullWidth
                        size="small"
                        sx={{ height: "35px" }}
                      >
                        Add Product
                      </Button>
                    )}
                  </Box>
                </Grid>
              </Stack>
            )}
            {filteredProducts.length > 0 && (
              <Box
                sx={{
                  mt: 1,
                  borderRadius: "8px",
                  backgroundColor: "white",
                  zIndex: 10,
                  position: "absolute",
                  width: "61vw",
                  boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.08)",
                  paddingX: "6px",
                  paddingY: "15px",
                }}
              >
                {filteredProducts.map((product) => (
                  <Grid
                    container
                    key={product.productId}
                    alignItems="center"
                    sx={{
                      cursor: "pointer",
                      "&:hover": { backgroundColor: "#F0F0F0" },
                      p: 1,
                      borderRadius: "4px",
                    }}
                    onClick={() => {
                      setCopyItemFromSuggestion(true);
                      // setStoreFormData((prev) => ({
                      //   ...prev,
                      //   currentProduct: {
                      //     productName: product?.productName || "",
                      //     productCategory: product?.productCategory || "",
                      //     productBrand: product?.productBrand || "",
                      //     productPrice: product?.productPrice || "",
                      //     productWeight: product?.productWeight || "",
                      //     productStock: product?.productStock || "",
                      //     productDimentionL: product?.productDimentionL || "",
                      //     productDimentionW: product?.productDimentionW || "",
                      //     productDimentionH: product?.productDimentionH || "",
                      //     productDescription: product?.productDescription || "",
                      //     productTags: product?.productTags || [],
                      //     productImage: product?.productImage || [],
                      //     productVarient: product?.productVarient || [],
                      //     productUnderReview:
                      //       product?.productUnderReview || false,
                      //   },
                      // }));
                      setProductCatalogData((prev) => ({
                        ...prev,
                        parcelProducts: [
                          ...prev.parcelProducts, // Keep existing products
                          {
                            id: product?.id || "",
                            name: product?.productName || "",
                            quantity: product?.productStock || 1,
                            weight: product?.productWeight || 0,
                            price: product?.productPrice || 0,
                          },
                        ],
                        productName: "",
                      }));
                      setSelectedCategory(product?.productCategory);
                      setVariants(product?.productVarient || []);
                      setSelectedValue(product?.productTags || []);
                      setSelectedProductDesignation(
                        product?.productDesignation || []
                      );
                      setFilteredProducts([]);
                    }}
                  >
                    <Grid item xs={1}>
                      <Box display="flex" alignItems="center">
                        {product?.productImage?.length > 0 ? (
                          <img
                            src={
                              product?.productImage?.length > 0
                                ? product?.productImage[0]
                                : product?.productImage
                            }
                            alt={product.productName}
                            style={{
                              width: "28px",
                              height: "28px",
                              borderRadius: "4px",
                              marginLeft: "20px",
                            }}
                          />
                        ) : (
                          <div
                            style={{
                              width: "28px",
                              height: "28px",
                              marginLeft: "20px",
                              borderRadius: "4px",
                              backgroundColor: "#8770DE",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              color: "#fff",
                              fontSize: "16px",
                            }}
                          >
                            {product?.productName?.charAt(0).toUpperCase()}
                          </div>
                        )}
                      </Box>
                    </Grid>
                    <Grid item xs={3}>
                      <Box display="flex" alignItems="center">
                        <Typography sx={{ fontSize: "12px" }}>
                          {highlightText(
                            product.productName,
                            storeformData.currentProduct?.productName
                          )}
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={3}>
                      <Typography sx={{ fontSize: "12px" }}>
                        {product.productId}
                      </Typography>
                    </Grid>
                    <Grid item xs={3}>
                      <Typography sx={{ fontSize: "12px" }}>
                        {product.productCategory}
                      </Typography>
                    </Grid>
                    <Grid item xs={2}>
                      <Typography sx={{ fontSize: "12px" }}>
                        {product.productPrice}
                      </Typography>
                    </Grid>
                  </Grid>
                ))}
              </Box>
            )}

            {productCatalogData.productType && (
              <Stack direction="row" sx={{ marginTop: "20px" }} gap={2}>
                <Card sx={{ width: "100%", paddingX: "10px", paddingY: "5px" }}>
                  <TableContainer component={Paper} sx={{ marginTop: "10px" }}>
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell>Product</TableCell>
                          <TableCell>Quantity</TableCell>
                          <TableCell>Weight</TableCell>
                          <TableCell>Price</TableCell>
                          <TableCell align="center">Actions</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {productCatalogData.parcelProducts.length === 0 ? (
                          <TableRow>
                            <TableCell colSpan={5} align="center">
                              <Typography variant="body1" color="textSecondary">
                                No products added
                              </Typography>
                            </TableCell>
                          </TableRow>
                        ) : (
                          productCatalogData.parcelProducts.map((product) => (
                            <TableRow key={product.id}>
                              <TableCell>{product.name}</TableCell>
                              <TableCell>
                                <TextField
                                  type="number"
                                  value={product.quantity}
                                  onChange={(e) =>
                                    handleEditParcelProduct(
                                      product.id,
                                      "quantity",
                                      e.target.value
                                    )
                                  }
                                  size="small"
                                  variant="outlined"
                                />
                              </TableCell>
                              <TableCell>
                                <TextField
                                  type="number"
                                  step="0.01"
                                  value={product.weight}
                                  onChange={(e) =>
                                    handleEditParcelProduct(
                                      product.id,
                                      "weight",
                                      e.target.value
                                    )
                                  }
                                  size="small"
                                  variant="outlined"
                                />
                              </TableCell>
                              <TableCell>
                                <TextField
                                  type="number"
                                  step="0.01"
                                  value={product.price}
                                  onChange={(e) =>
                                    handleEditParcelProduct(
                                      product.id,
                                      "price",
                                      e.target.value
                                    )
                                  }
                                  size="small"
                                  variant="outlined"
                                />
                              </TableCell>
                              <TableCell align="center">
                                <IconButton
                                  color="error"
                                  onClick={() =>
                                    handleDeleteParcelProduct(product.id)
                                  }
                                >
                                  <DeleteIcon />
                                </IconButton>
                              </TableCell>
                            </TableRow>
                          ))
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Card>
              </Stack>
            )}
            {productCatalogData.productType && (
              <Stack
                direction={"row"}
                gap={3}
                sx={{
                  marginTop: "10px",
                }}
              >
                <Grid container spacing={2}>
                  <Grid item xs={4}>
                    <Typography sx={{ fontSize: "14px", fontWeight: "500" }}>
                      Total Weight (Auto-calculated)
                      {/* <span style={{ color: "#FF5630" }}>*</span> */}
                    </Typography>
                    <FormControl
                      fullWidth
                      sx={{ mt: 1, minWidth: "10vw" }}
                      size="small"
                    >
                      <OutlinedInput
                        disabled={true}
                        type="text"
                        sx={{ height: "35px" }}
                        placeholder="Total Weight"
                        name="totalWeight"
                        // value={storeformData.parcelDetails?.totalWeight || ""}
                        value={productCatalogData.totalWeight || ""}
                        onChange={handleChangeFormData}
                        autoComplete="off"
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={4}>
                    <Typography sx={{ fontSize: "14px", fontWeight: "500" }}>
                      Full Price (Auto-calculated)
                      {/* <span style={{ color: "#FF5630" }}>*</span> */}
                    </Typography>
                    <FormControl
                      fullWidth
                      sx={{ mt: 1, minWidth: "10vw" }}
                      size="small"
                    >
                      <OutlinedInput
                        disabled={true}
                        type="text"
                        sx={{ height: "35px" }}
                        placeholder="Full Price"
                        name="fullPrice"
                        // value={storeformData.parcelDetails?.fullPrice || ""}
                        value={productCatalogData.fullPrice || ""}
                        onChange={handleChangeFormData}
                        autoComplete="off"
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={4}>
                    <Typography sx={{ fontSize: "14px", fontWeight: "500" }}>
                      Parcel Price (Admin Editable)
                      {/* <span style={{ color: "#FF5630" }}>*</span> */}
                    </Typography>
                    <FormControl
                      fullWidth
                      sx={{ mt: 1, minWidth: "10vw" }}
                      size="small"
                    >
                      <OutlinedInput
                        disabled={true}
                        type="text"
                        sx={{ height: "35px" }}
                        placeholder="Parcel Price"
                        name="parcelPrice"
                        // value={storeformData.parcelDetails?.parcelPrice || ""}
                        value={productCatalogData.parcelPrice || ""}
                        onChange={handleChangeFormData}
                        autoComplete="off"
                      />
                    </FormControl>
                  </Grid>
                </Grid>
              </Stack>
            )}

            <Stack direction="row" sx={{ marginTop: "20px" }} gap={2}>
              <Grid item>
                <Typography sx={{ fontSize: "14px", fontWeight: "500" }}>
                  Category<span style={{ color: "#FF5630" }}>*</span>
                </Typography>
                <FormControl fullWidth sx={{ mt: 1 }} size="small">
                  <Select
                    displayEmpty
                    sx={{ height: "35px", minWidth: "30vw" }}
                    name="productCategory"
                    // value={storeformData.currentProduct?.productCategory || ""}
                    value={productCatalogData.productCategory || ""}
                    onChange={handleChangeFormData}
                  >
                    <MenuItem value="" disabled>
                      Select
                    </MenuItem>
                    {categories.map((category, index) => (
                      <MenuItem key={index} value={category}>
                        {category}
                      </MenuItem>
                    ))}
                  </Select>
                  {errors.productCategory && (
                    <Typography
                      sx={{ color: "red", fontSize: "12px", marginTop: "4px" }}
                    >
                      {errors.productCategory}
                    </Typography>
                  )}
                </FormControl>
              </Grid>
              <Grid item>
                <Typography
                  sx={{
                    fontSize: "14px",
                    fontWeight: "500",
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  Brand{" "}
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => setBrandToggal(true)}
                    disabled={
                      storeformData.currentProduct?.productCategory === ""
                    }
                    sx={{
                      fontSize: "12px",
                      height: "20px",
                    }}
                  >
                    Add Brand
                  </Button>
                </Typography>
                <FormControl fullWidth sx={{ mt: 1 }} size="small">
                  <Select
                    displayEmpty
                    sx={{ height: "35px", minWidth: "30vw" }}
                    name="productBrand"
                    // value={storeformData.currentProduct?.productBrand || ""}
                    value={productCatalogData.productBrand || ""}
                    onChange={handleChangeFormData}
                  >
                    <MenuItem value="" disabled>
                      Select
                    </MenuItem>
                    {filteredBrands.map((brand, index) => (
                      <MenuItem key={index} value={brand.brandName}>
                        {brand.brandName}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            </Stack>

            <Box
              sx={{
                display: "flex",
                mt: "24px",
              }}
            >
              <FileUploadNewVersion
                name="images"
                onChange={onUploadChange}
                refresh={selectedFiles}
              />
            </Box>

            <Stack direction="row" sx={{ marginTop: "20px" }} gap={3}>
              <Grid container spacing={2}>
                <Grid item xs={4}>
                  <Typography sx={{ fontSize: "14px", fontWeight: "500" }}>
                    Price ({storeformData?.storeCurrency})
                    <span style={{ color: "#FF5630" }}>*</span>
                  </Typography>
                  <FormControl fullWidth sx={{ mt: 1 }} size="small">
                    <OutlinedInput
                      type="text"
                      placeholder="Price"
                      sx={{ height: "35px" }}
                      name="productPrice"
                      // value={storeformData.currentProduct?.productPrice || ""}
                      value={productCatalogData.productPrice || ""}
                      onChange={handleChangeFormData}
                    />
                    {errors.productPrice && (
                      <Typography
                        sx={{
                          color: "red",
                          fontSize: "12px",
                          marginTop: "4px",
                        }}
                      >
                        {errors.productPrice}
                      </Typography>
                    )}
                  </FormControl>
                </Grid>
                <Grid item xs={4}>
                  <Typography sx={{ fontSize: "14px", fontWeight: "500" }}>
                    Weight ({storeformData?.storeWeight})
                    <span style={{ color: "#FF5630" }}>*</span>
                  </Typography>
                  <FormControl fullWidth sx={{ mt: 1 }} size="small">
                    <OutlinedInput
                      sx={{ height: "35px" }}
                      type="text"
                      name="productWeight"
                      placeholder="Weight"
                      // value={storeformData.currentProduct?.productWeight || ""}
                      value={productCatalogData.productWeight || ""}
                      onChange={handleChangeFormData}
                    />
                    {errors.productWeight && (
                      <Typography
                        sx={{
                          color: "red",
                          fontSize: "12px",
                          marginTop: "4px",
                        }}
                      >
                        {errors.productWeight}
                      </Typography>
                    )}
                  </FormControl>
                </Grid>
                <Grid item xs={4}>
                  <Typography sx={{ fontSize: "14px", fontWeight: "500" }}>
                    Stock<span style={{ color: "#FF5630" }}>*</span>
                  </Typography>
                  <FormControl fullWidth sx={{ mt: 1 }} size="small">
                    <OutlinedInput
                      type="text"
                      sx={{ height: "35px" }}
                      placeholder="Stock"
                      name="productStock"
                      // value={storeformData.currentProduct?.productStock || ""}
                      value={productCatalogData.productStock || ""}
                      onChange={handleChangeFormData}
                    />
                    {errors.productStock && (
                      <Typography
                        sx={{
                          color: "red",
                          fontSize: "12px",
                          marginTop: "4px",
                        }}
                      >
                        {errors.productStock}
                      </Typography>
                    )}
                  </FormControl>
                </Grid>
              </Grid>
            </Stack>

            <Stack direction="row" sx={{ marginTop: "20px" }} gap={3}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Typography sx={{ fontSize: "14px", fontWeight: "500" }}>
                    Dimensions (cm)
                  </Typography>
                </Grid>
                <Grid
                  item
                  xs={4}
                  sx={{ display: "flex", alignItems: "center" }}
                >
                  <Box sx={{ marginRight: "6px" }}>L</Box>
                  <FormControl fullWidth size="small">
                    <OutlinedInput
                      sx={{ height: "35px" }}
                      type="text"
                      name="productDimentionL"
                      placeholder="Length"
                      // value={
                      //   storeformData.currentProduct?.productDimentionL || ""
                      // }
                      value={productCatalogData.productDimentionL || ""}
                      onChange={handleChangeFormData}
                    />
                  </FormControl>
                </Grid>
                <Grid
                  item
                  xs={4}
                  sx={{ display: "flex", alignItems: "center" }}
                >
                  <Box sx={{ marginRight: "6px" }}>W</Box>
                  <FormControl fullWidth size="small">
                    <OutlinedInput
                      type="text"
                      name="productDimentionW"
                      sx={{ height: "35px" }}
                      placeholder="Width"
                      // value={
                      //   storeformData.currentProduct?.productDimentionW || ""
                      // }
                      value={productCatalogData.productDimentionW || ""}
                      onChange={handleChangeFormData}
                    />
                  </FormControl>
                </Grid>
                <Grid
                  item
                  xs={4}
                  sx={{ display: "flex", alignItems: "center" }}
                >
                  <Box sx={{ marginRight: "6px" }}>H</Box>
                  <FormControl fullWidth size="small">
                    <OutlinedInput
                      type="text"
                      sx={{ height: "35px" }}
                      name="productDimentionH"
                      placeholder="Height"
                      // value={
                      //   storeformData.currentProduct?.productDimentionH || ""
                      // }
                      value={productCatalogData.productDimentionH || ""}
                      onChange={handleChangeFormData}
                    />
                  </FormControl>
                </Grid>
              </Grid>
            </Stack>

            <Stack sx={{ marginTop: 2 }}>
              <Typography sx={{ fontSize: "14px", fontWeight: "500" }}>
                Description<span style={{ color: "#FF5630" }}>*</span>
              </Typography>
              <FormControl fullWidth sx={{ mt: 1 }} size="small">
                <OutlinedInput
                  type="text"
                  name="productDescription"
                  multiline
                  minRows={5}
                  placeholder="Enter Description"
                  // value={storeformData.currentProduct?.productDescription || ""}
                  value={productCatalogData.productDescription || ""}
                  onChange={handleChangeFormData}
                />
                {errors.productDescription && (
                  <Typography
                    sx={{
                      color: "red",
                      fontSize: "12px",
                      marginTop: "4px",
                    }}
                  >
                    {errors.productDescription}
                  </Typography>
                )}
              </FormControl>
            </Stack>

            <Stack sx={{ marginTop: 2 }}>
              <Typography sx={{ fontSize: "14px", fontWeight: "500" }}>
                Product Designation
              </Typography>
              <Autocomplete
                size="small"
                sx={{ height: "35px" }}
                multiple
                options={["Top picks today", "Top ship"]}
                freeSolo
                value={selectedProductDesignation}
                onChange={handleChangeDesignation}
                renderInput={(params) => (
                  <TextField
                    sx={{ height: "35px" }}
                    {...params}
                    placeholder="Search"
                    size="small"
                  />
                )}
                renderTags={() => null}
              />
              <Box
                sx={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: 1,
                  marginTop: "8px",
                }}
              >
                {selectedProductDesignation?.map((tag, index) => (
                  <Chip
                    sx={{
                      backgroundColor: "rgba(238, 238, 238, 1)",
                      fontSize: "14px",
                      fontWeight: 500,
                      height: "28px",
                    }}
                    key={index}
                    label={tag}
                    onDelete={() => {
                      setSelectedProductDesignation((prev) =>
                        prev.filter((_, i) => i !== index)
                      );
                    }}
                  />
                ))}
              </Box>
            </Stack>

            <Stack sx={{ marginTop: 2, marginBottom: 2 }}>
              <Typography sx={{ fontSize: "14px", fontWeight: "500" }}>
                Tags
              </Typography>
              <Autocomplete
                size="small"
                sx={{ height: "35px" }}
                multiple
                options={["Tags", "Tag choice 2", "Tag choice 3"]}
                freeSolo
                value={selectedValue}
                onChange={handleChangeTags}
                renderInput={(params) => (
                  <TextField
                    sx={{ height: "35px" }}
                    {...params}
                    placeholder="Search"
                    size="small"
                  />
                )}
                renderTags={() => null}
              />
              <Box
                sx={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: 1,
                  marginTop: "8px",
                }}
              >
                {selectedValue?.map((tag, index) => (
                  <Chip
                    sx={{
                      backgroundColor: "rgba(238, 238, 238, 1)",
                      fontSize: "14px",
                      fontWeight: 500,
                      height: "28px",
                    }}
                    key={index}
                    label={tag}
                    onDelete={() => {
                      setSelectedValue((prev) =>
                        prev.filter((_, i) => i !== index)
                      );
                    }}
                  />
                ))}
              </Box>
            </Stack>

            <Stack sx={{ marginTop: 2 }}>
              <Typography sx={{ fontSize: "14px", fontWeight: "500" }}>
                Key Features
              </Typography>
              <FormControl fullWidth sx={{ mt: 1 }} size="small">
                <OutlinedInput
                  type="text"
                  name="productKeyFeatures"
                  multiline
                  minRows={5}
                  placeholder="Enter Key Features"
                  // value={storeformData.currentProduct?.productKeyFeatures || ""}
                  value={productCatalogData.productKeyFeatures || ""}
                  onChange={handleChangeFormData}
                />
              </FormControl>
            </Stack>

            <Stack sx={{ marginTop: 2 }}>
              <Typography sx={{ fontSize: "14px", fontWeight: "500" }}>
                Use Case
              </Typography>
              <FormControl fullWidth sx={{ mt: 1 }} size="small">
                <OutlinedInput
                  type="text"
                  name="productUseCase"
                  multiline
                  minRows={5}
                  placeholder="Enter Use Case"
                  // value={storeformData.currentProduct?.productUseCase || ""}
                  value={productCatalogData.productUseCase || ""}
                  onChange={handleChangeFormData}
                />
              </FormControl>
            </Stack>

            <Stack sx={{ marginTop: 2 }}>
              <Typography sx={{ fontSize: "14px", fontWeight: "500" }}>
                Benefits
              </Typography>
              <FormControl fullWidth sx={{ mt: 1 }} size="small">
                <OutlinedInput
                  type="text"
                  name="productBenefits"
                  multiline
                  minRows={5}
                  placeholder="Enter Benefits"
                  // value={storeformData.currentProduct?.productBenefits || ""}
                  value={productCatalogData.productBenefits || ""}
                  onChange={handleChangeFormData}
                />
              </FormControl>
            </Stack>

            <Stack sx={{ marginTop: 2 }}>
              <Typography sx={{ fontSize: "14px", fontWeight: "500" }}>
                Nutritional value
              </Typography>
              <FormControl fullWidth sx={{ mt: 1 }} size="small">
                <OutlinedInput
                  type="text"
                  name="productNutritionalValue"
                  multiline
                  minRows={5}
                  placeholder="Enter Nutritional value"
                  // value={
                  //   storeformData.currentProduct?.productNutritionalValue || ""
                  // }
                  value={productCatalogData.productNutritionalValue || ""}
                  onChange={handleChangeFormData}
                />
              </FormControl>
            </Stack>

            <Stack sx={{ marginTop: 2 }}>
              <Typography sx={{ fontSize: "14px", fontWeight: "500" }}>
                Product Specifications
              </Typography>
              <FormControl fullWidth sx={{ mt: 1 }} size="small">
                <OutlinedInput
                  type="text"
                  name="productProductSpecifications"
                  multiline
                  minRows={5}
                  placeholder="Enter Product Specifications"
                  // value={
                  //   storeformData.currentProduct
                  //     ?.productProductSpecifications || ""
                  // }
                  value={productCatalogData.productProductSpecifications || ""}
                  onChange={handleChangeFormData}
                />
              </FormControl>
            </Stack>

            <Stack sx={{ marginTop: 2 }}>
              <Typography sx={{ fontSize: "14px", fontWeight: "500" }}>
                Target Audience
              </Typography>
              <FormControl fullWidth sx={{ mt: 1 }} size="small">
                <OutlinedInput
                  type="text"
                  name="productTagretAudience"
                  multiline
                  minRows={5}
                  placeholder="Enter Target Audience"
                  // value={
                  //   storeformData.currentProduct?.productTagretAudience || ""
                  // }
                  value={productCatalogData.productTagretAudience || ""}
                  onChange={handleChangeFormData}
                />
              </FormControl>
            </Stack>

            <AddVariant
              onAddVariant={handleAddVariant}
              clearVariant={clearVariant}
              // whileEditVarinet={storeformData?.currentProduct?.productVarient}
              whileEditVarinet={productCatalogData.productVarient}
              copyItemFromSuggestion={copyItemFromSuggestion}
            />

            {variants.length > 0 && (
              <VariantTable
                variants={variants}
                // productDetails={storeformData.currentProduct}
                productDetails={productCatalogData.productVarient}
              />
            )}
          </Box>
        </SimpleBar>
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            borderTop: "1px solid #E5E5E8",
          }}
        >
          <Box>
            <Button
              variant="contained"
              sx={{
                backgroundColor: "white",
                color: "#1C2630",
                border: "1px solid #E5E5E8",
                minWidth: "126px",
                borderRadius: "4px",
                boxShadow: "none",
                whiteSpace: "nowrap",
                fontWeight: 600,
                marginTop: "20px",
                "&:hover": {
                  outline: "none",
                  color: "#1C2630",
                  backgroundColor: "white",
                },
              }}
              onClick={() => {
                setStoreFormData({
                  storeID: uuidv4(),
                  storeName: "",
                  storeLocation: "",
                  storeDescription: "",
                  storeShipment: "",
                  storeCreatedDate: new Date(),
                  products: [],
                });
                // setStoreFormData((prev) => ({
                //   ...prev,
                //   currentProduct: {
                //     productId: "",
                //     productName: "",
                //     productCategory: "",
                //     productBrand: "",
                //     productPrice: "",
                //     productWeight: "",
                //     productStock: "",
                //     productDimentionL: "",
                //     productDimentionW: "",
                //     productDimentionH: "",
                //     productDescription: "",
                //     productTags: [],
                //     productImage: [],
                //     productVarient: [],
                //     productStatus: user?.role === "Superadmin" ? true : false,
                //     productUnderReview: false,
                //   },
                // }));
                setProductCatalogData((prev) => ({
                  ...prev,
                  productType: false,
                  parcelName: "",
                  totalWeight: "",
                  fullPrice: "",
                  parcelPrice: "",
                  parcelProducts: [],
                  storeImages: [],
                  productBrand: "",
                  productCategory: "",
                  productImage: "",
                  productDescription: "",
                  productDimentionH: 0,
                  productDimentionL: 0,
                  productDimentionW: 0,
                  productName: "",
                  productPrice: 0,
                  productStock: 0,
                  productWeight: 0,
                  productVarient: [],
                  productKeyFeatures: "",
                  productUseCase: "",
                  productBenefits: "",
                  productNutritionalValue: "",
                  productProductSpecifications: "",
                  productTags: [],
                  productDesignation: "",
                }));
                setCheckForEdit(false);
                setCopyItemFromSuggestion(false);
                setAddProductFromOverview(false);
                setProductIdForEdit();
                setAddProductFromOverviewDocId();
                {
                  checkForEdit === true && productCatalog === true
                    ? navigate("/shopping/add-products")
                    : navigate("/shopping/store");
                }
              }}
            >
              Cancel
            </Button>
          </Box>
          <Box>
            <Button
              variant="contained"
              onClick={handleSave}
              sx={{
                backgroundColor: "#5E17EB",
                color: "#fff",
                marginLeft: "20px",
                minWidth: "126px",
                border: "1px solid #E5E5E8",
                borderRadius: "4px",
                boxShadow: "none",
                whiteSpace: "nowrap",
                fontWeight: 600,
                marginTop: "20px",
                "&:hover": {
                  outline: "none",
                  color: "#fff",
                  backgroundColor: "#5E17EB",
                },
              }}
            >
              Save
            </Button>
          </Box>
        </Box>
      </Box>
      {brandToggal && (
        <AddBrand
          open={brandToggal}
          onClose={toggleBrand}
          productCategory={storeformData.currentProduct?.productCategory}
        />
      )}
    </>
  );
}

export default AddProductCatalog;
